// Submodule of company module
// import Vue from "vue";
import _ from "lodash";
import { getField, updateField } from "vuex-map-fields";
import { RESET, UPDATE_ABONNEMENT, GENERATE_TOKEN } from "@/store/action-types";
import { RESET_STATE } from "@/store/mutation-types";
import { Company } from "@/models/Company";
import companiesRepository from "../../../../utils/companiesRepository";

const getDefaultState = () => ({
  entity: new Company()
});

const actions = {
  [RESET]({ commit }) {
    commit(RESET_STATE);
  },
  [UPDATE_ABONNEMENT](
    { commit, getters },
    {
      applicationId,
      field = "",
      value,
      array,
      toggle,
      add = false,
      fieldToCompare
    }
  ) {
    let abonnement = getters.getAbonnementByApplicationId(applicationId);

    if (abonnement !== undefined) {
      if (array) {
        if (toggle === false) {
          commit("sliceAbonnementsFieldArray", {
            abonnement,
            field,
            value,
            fieldToCompare
          });
        } else {
          commit("mergeAbonnementsFieldArray", {
            abonnement,
            field,
            value
          });
        }

        return;
      }
    }

    commit("updateAbonnements", {
      abonnement,
      value: _.set({ applicationId }, field, array ? [value] : value),
      add
    });
  },
  async [GENERATE_TOKEN]({ commit, state }, { nbToken, applicationId }) {
    let companyId = state.entity.id;
    try {
      return companiesRepository.generateToken({
        companyId: companyId,
        nbToken: nbToken,
        applicationId: applicationId
      });

      //   return data.content.acces;
    } catch (error) {
      commit();
      //commit(`app/${ERROR}`, { error, message: error.message }, { root: true });
    }
  }
};

const mutations = {
  updateField,
  [RESET_STATE](state) {
    Object.assign(state, getDefaultState());
  },
  updateAbonnements(state, { abonnement, value, add = false }) {
    if (abonnement && !add) {
      if (abonnement.acces && value.acces) {
        value.acces = [...abonnement.acces, ...value.acces];
      }

      _.merge(abonnement, value);
    } else {
      state.entity.abonnements.push(value);
    }
  },
  sliceAbonnementsFieldArray(
    state,
    { abonnement, field, value, fieldToCompare = "droitId" }
  ) {
    _.remove(
      _.get(abonnement, field),
      el => _.get(el, fieldToCompare) === _.get(value, fieldToCompare)
    );
  },
  mergeAbonnementsFieldArray(state, { abonnement, field, value }) {
    _.set(abonnement, field, _.union(_.get(abonnement, field), [value]));
  }
};

const getters = {
  getField,
  getAbonnementByApplicationId: state => applicationId =>
    state.entity.abonnements.find(
      abonnement => abonnement.applicationId == applicationId
    )
};

const state = () => getDefaultState();

export default {
  namespaced: true,
  actions,
  mutations,
  getters,
  state
};
